import getCSSRule from './getCSSRule';

const addCSSRule = (ruleName, bypassCheck) => {
    const defaultSheetId = 'apexchat_default';

    try {
        if (document.styleSheets) {
            if (bypassCheck || !getCSSRule(ruleName, defaultSheetId)) {
                if (!document.getElementById(defaultSheetId)) {
                    const cssNode = document.createElement('style');
                    cssNode.type = 'text/css';
                    cssNode.rel = 'stylesheet';
                    cssNode.media = 'screen';
                    cssNode.title = defaultSheetId;
                    cssNode.id = defaultSheetId;
                    document.getElementsByTagName('head')[0].appendChild(cssNode);
                }
                let sheet = null;
                try {
                    const el = document.getElementById(defaultSheetId);
                    if (el) {
                        sheet = el.styleSheet || el.sheet;
                    }
                } catch (e0) { }
                if (!sheet) {
                    for (let i = 0; i < document.styleSheets.length; i++) {
                        try {
                            if (document.styleSheets[i].title == defaultSheetId) {
                                sheet = document.styleSheets[i];
                                break;
                            }
                        } catch (e1) {
                            // security exceptions are possible here
                        }
                    }
                    if (!sheet) {
                        sheet = document.styleSheets[0];
                    }
                }
                try {
                    if (sheet.addRule) {
                        sheet.addRule(ruleName, null, 0); // Yes, add IE style
                    } else {
                        sheet.insertRule(`${ruleName} { }`, 0); // Yes, add Moz style.
                    }
                } catch (e2) {
                    // gah...ignore it
                }
            }
        }
    } catch (e) {
        if (window && window.console && window.console.error) {
            window.console.error(e);
        }
    }
    return getCSSRule(ruleName, defaultSheetId);
};
export default addCSSRule;
